import { createFileRoute } from "@tanstack/react-router";
import { CompetencyLibraryScreen } from "@modules/competencies/views";
import { requireSurface } from "../-guards";

// /staff/competencies — « Bibliothèque de compétences », the ACQUIRE competency spine (E10).
//
// Guarded on `round_configuration` like the rest of the staff tree: the library is the method
// the foundation configures, so it belongs to the same surface as round configuration rather
// than to a permission of its own.
//
// Registered in the sidebar under ACQUIRE alongside the question bank (routes/-staff-nav.ts).
export const Route = createFileRoute("/staff/competencies")({
  beforeLoad: ({ context, location }) =>
    requireSurface(
      context.queryClient,
      "round_configuration",
      location.pathname
    ),
  component: CompetencyLibraryScreen,
});
